import axios from 'axios';
import join from 'url-join';
import {
  server,
  sysURL,
  NOT_CONNECT_NETWORK,
  NETWORK_CONNECTION_MESSAGE,
} from './../constants';
import { JSON2HTML } from './../utils/utils';

import { useHistory } from 'react-router-dom';
import { useDialog } from './../contexts/DialogContext';

/**==============================================================================================================
 * Axios & built-in accessToken for request-api
 * ==============================================================================================================
 */
const axioses = axios.create();
// Local constant

const ATHEN_FALSE_TITLE = 'New data authorization has error occurred!';
const ATHEN_EXCEPTION = 'Auth Exception';

const isAbsoluteURLRegex = /^(?:\w+:)\/\//;

// FIXME: Axios cancelled requests can't be restarted (https://github.com/axios/axios/issues/1330)
// TODO : https://stackoverflow.com/questions/53475045/axios-cancelled-requests-cant-be-restarted
// FIXED: Axios cancelled requests can't be restarted (https://github.com/axios/axios#cancellation)
// OTHER INFO: https://github.com/axios/axios/issues/1330

// Axioses propoties that assigned by axios
axioses.CancelToken = axios.CancelToken;
axioses.isCancel = axios.isCancel;
axioses.Cancel = axios.Cancel;

// How to axios cancellation https://github.com/axios/axios#cancellation
let axios_cancelToken = null;
let axios_cancelTokenAgent;
let axios_isCancelTokenNew = true;

axioses.interceptors.request.use(
  async (config) => {
    // Do something before request is sent (axios ofc)

    // Create axios_cancelToken
    if (axios_isCancelTokenNew) {
      axios_cancelToken = new axioses.CancelToken(function executor(c) {
        axios_cancelTokenAgent = c;
      });
      axios_isCancelTokenNew = false;
    }

    // Check url path if it is relative path then join after api-domian (urlApi)
    if (!isAbsoluteURLRegex.test(config.url)) {
      config.url = join(sysURL.api, config.url);
    }
    const accessToken = localStorage.getItem(server.ACCESS_TOKEN_KEY);
    config.headers = {
      Authorization: accessToken,
    };
    config.cancelToken = axios_cancelToken;
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor (axios ofc(officeial))
axioses.interceptors.response.use(
  (response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger  (axios ofc)
    // Do something with response data
    if (response.data.status === false) {
      return Promise.reject({
        response,
        message: response.data.message,
        name: 'Error',
      });
    }
    return response;
  },
  async (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger  (axios ofc)
    // Do something with response error'

    if (axioses.isCancel(error)) {
      console.error(`Request canceled because, ${error}`);
      return Promise.reject(error);
    } else if (!error.response) {
      return Promise.reject({
        message: `${NETWORK_CONNECTION_MESSAGE} ${error.message}`,
        name: NOT_CONNECT_NETWORK,
      });
    }

    if (error.response.status === 401) {
      try {
        // let n = null;
        // let s = n.toString();
        // Prease use pure axios for urlAccessToken for fiexed error from header authorization of axios
        let respAccessToken = await axios.get(sysURL.accessToken);
        let { data } = respAccessToken;
        if (data.status === true) {
          // jsSnackbar("Data authorized");
          localStorage.setItem(server.ACCESS_TOKEN_KEY, data.tokenAccess);
          return axioses.request(error.config);
        } else {
          throw new Error(`${ATHEN_FALSE_TITLE}, Message: ${data.message}`);
        }
      } catch (catchError) {
        return Promise.reject({
          message: catchError.message,
          name: ATHEN_EXCEPTION,
        });
      }
    }
    return Promise.reject(error);
  }
);

/**
 * Hook handler handleClientError
 * Dependencies: useDialog, useHistory
 * @return handleClientError(error, infoPath), Show dialog error messages or redirect to app-info page
 */
export function useHandleClientError() {
  const [openDialog /*, closeDialog*/] = useDialog();
  const history = useHistory();
  /**
   *
   * @param {object} error,  object error messages
   * @param {string} infoPath, route path to display messages-json-string
   */
  const handleClientError = (error = {}, infoPath = '/info') => {
    // Assign error2JSON with JSON error messages from  (fnc) error.toJSON (toJSON is the feuture from axios )
    // (if (fnc) toJSON does not exist in error, let create JSON with error messages and prop.name = "Error from Exception")
    let error2JSON = {
      message: error.message,
      name: error.name,
      'process name': (() => {
        try {
          if (error.response.data.process) {
            return error.response.data.process;
          }
        } catch (error) {}
        return 'N/A';
      })(),
    };

    if (!axioses.isCancel(error)) {
      // Cancel another request by axios_cancelTokenAgent
      if (typeof axios_cancelTokenAgent === 'function') {
        axios_cancelTokenAgent(`${error2JSON.message}`);
      }

      // localStorage.setItem(server.INFO_KEY, JSON.stringify(error2JSON));

      (() => {
        if (error2JSON.name === ATHEN_EXCEPTION) {
          console.error(ATHEN_EXCEPTION, error2JSON.message);
        } else {
          return openDialog({
            id: 'clientErrorDialog',
            title: 'Error Occured',
            summary: error2JSON,
            detail: error.response
              ? error.response.data
                ? error.response.data
                : null
              : null,
            onClose: () => {
              axios_isCancelTokenNew = true;
              // // Check each status (code) when you set to redirect page after click close
              // if (error.hasOwnProperty('response')) {
              //   let status = error.response.status;
              //   switch (status) {
              //     // cose 401 skiped because auto get new token_access when expire
              //     case 401:
              //       // history.push(infoPath);
              //       break;
              //     default:
              //       history.push(infoPath);
              //   }
              //   // error from cancel or net work error
              // } else {
              //   history.push(infoPath);
              // }
            },
          });
        }
      })();
    }
  };

  return handleClientError;
}
/**
 * export httpClient for external use request-api
 */
export const httpClient = axioses;

/** ===============================================================================================================
 * Test mutableValue
 * ================================================================================================================
 */
let mutable_count = 1;
export const mutableCount = {
  run() {
    console.warn('Testing run mutableCount before ', { mutable_count });
    mutable_count++;
  },
  log() {
    console.warn('Testing run mutableCount after ', { mutable_count });
  },
};
